"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "players-overview-settings" };
const _hoisted_2 = { class: "setting-label" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
            class: "setting-button",
            onClick: _cache[0] || (_cache[0] = (0, vue_1.withModifiers)(($event) => (_ctx.toggleTagsView()), ["prevent"]))
        }, [
            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getTagToggleLabel()), 1)
        ])), [
            [_directive_i18n]
        ]),
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                (0, vue_1.createTextVNode)("[ toggle tags view ]", -1)
            ]))])), [
            [_directive_i18n]
        ])
    ]));
}
